import { render, staticRenderFns } from "./UseTypeBadge.vue?vue&type=template&id=a1af35ec&scoped=true&"
import script from "./UseTypeBadge.vue?vue&type=script&lang=js&"
export * from "./UseTypeBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1af35ec",
  null
  
)

export default component.exports